import { MixPanelEventEmitter } from '../metrics/MixPanelEventEmitter';
import { IHeaderTabGroup, IHeaderTab } from '../HeaderTabs';

export class CalendarTabsProvider {

    static inject = () => [MixPanelEventEmitter];
    constructor(private tracking: MixPanelEventEmitter) {}

    getTabs = (careMap?: any): IHeaderTabGroup => {
        const tabs: IHeaderTab[] = [
            {
                label: 'Appointments',
                url: `/calendar/appointments`,
                dataId: 'appointments-tab'
            }
        ];

        // Only show tasks tab if user has permission (indicated by tasks link presence)
        if (careMap?.links?.tasks) {
            tabs.push({
                label: 'Tasks',
                url: `/calendar/tasks`,
                dataId: 'tasks-tab',
                onClick: () => {
                    this.tracking.track(
                        'Tasks Tab Opened',
                        () => ({'Opened From': 'Calendar Page'})
                    );
                }
            });
        }

        tabs.push({
            label: 'Journal',
            url: `/calendar/journal`,
            dataId: 'journal-tab',
            onClick: () => {
                this.tracking.track(
                    'Daily Log Calendar Opened',
                    () => ({'Opened From': 'Calendar Page'})
                );
            }
        });

        return {
            tabGroupId: 'calendar-tabs',
            tabs
        };
    };
}
